<!-- @veltra/icons generated sha256:0333fa18528e33be gen:8 source:src/svg/normal/flag.svg -->
<script setup lang="ts">
defineOptions({ name: 'Flag' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M3 8.998V2h10.46a.54.54 0 0 1 .54.54v6.92a.54.54 0 0 1-.54.54H4v4.499a.503.503 0 0 1-.496.501.504.504 0 0 1-.504-.501zm1-.491c0 .276.22.493.496.493h8.008A.49.49 0 0 0 13 8.507V3.493A.49.49 0 0 0 12.504 3H4.496A.49.49 0 0 0 4 3.493z"
    />
  </svg>
</template>
